import {
    Container,
    Col,
    Row,
} from "react-bootstrap";
import axios from "axios";
import React, { useState, useEffect } from "react";
import SyncLoader from "react-spinners/SyncLoader";

import DentistCards from '../cards/dentist_cards';
import './dentists.css'
import LanguageForm from "../forms/language-form";
import GenderForm from "../forms/gender-form";
import ReactPaginate from 'react-paginate';

// const proxyurl = "https://cors-anywhere.herokuapp.com/";

export default function Dentists(props) {

    const emirate = props.emirate;
    const [error, setError] = useState(null);
    const [page, setPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(10)
    const [loading, setLoading] = useState(true);
    const [dentists, setDentists] = useState([]);
    const [allDentists, setAllDentists] = useState([]);
    console.log()

    const sortLanguages = function (language)  {
      let result;
      if (language === 'All'){
        result = allDentists;
      } else {
        result = dentists.filter(dentist => 
          dentist.languages_spoken.includes(language));
      }
      setDentists(result);
    }

    const sortGender = function (gender)  {
      let result;
      if (gender === 'Both'){
        result = allDentists;
      } else {
        result = dentists.filter(dentist => 
          dentist.gender === gender);
      }
      setDentists(result);
    }

    useEffect(() => {
        console.log(props);
        axios.post("https://uae-dentist-backend.herokuapp.com/staff/get", {page, emirate})
          .then(
            (result) => {
              console.log(result.data);
              setDentists(result.data.dentists);
              setTotalPageCount(result.data.pageCount)
              setAllDentists(result.data.dentists);
              setLoading(false);
              console.log('Clinics Done')
            },
            (error) => {
              console.log(error)
              setLoading(false);
              setError(error);
            }
          );
      }, [emirate, page, props]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (loading) {
    return (
      <Container className="my-5" fluid="sm">
        <SyncLoader size={20} margin={3} color={"#123abc"} loading={loading} />
      </Container>
    );
  } else {
        return (
          <Col className='p-0' sm={12} md={2} lg={12} >
            <Row className='my-3'>
              <Col>
                <LanguageForm sortLanguages={sortLanguages}/>
                </Col>
              <Col>
                <GenderForm sortGender={sortGender}/>
              </Col>
            </Row>
            <DentistCards dentists={dentists}/>
            <div className='d-flex justify-content-center my-3'>
              <ReactPaginate
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                containerClassName={'pagination'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                activeClassName={'active'}
                previousLabel={'previous'}
                nextLabel={'next'}
                breakLabel={'...'}
                // breakClassName={'break-me'}
                pageCount={totalPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={setPage}
                // containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                // activeClassName={'active'}
              />
            </div>
            </Col>
        );
      }
    }
    